export default {
    HIOPOSWEBSERVICES: 'https://hiopos-demo.saas.com.co',
    HIOPOSREPORTS: 'https://hioposreports-demo.saas.com.co',
  }
